<footer class="container pb-4 d-flex flex-column flex-md-row justify-content-between align-items-center-md small ">
  <div>© {{year}} | Clooper</div>
  <div class="d-flex flex-column flex-md-row align-items-center-md gap-4 mt-3 mt-md-0">
    <!-- <div>GBP <i class="bi bi-chevron-down ms-1"></i><img src="assets/images/corporate-account/arr-down.svg" alt="arr-down" /></div> -->
    <a href="https://clooper.com/about" target="_blank" class=" text-decoration-none">About</a>
    <a href="/support-center" class=" text-decoration-none">Help & Support</a>
    <a href="https://clooper.com/blog/" target="_blank" class=" text-decoration-none">Blog</a>
    <a href="https://clooper.com/terms" target="_blank" class=" text-decoration-none">Terms & Conditions</a>
    <a href="https://clooper.com/privacy" target="_blank" class=" text-decoration-none">Privacy Policies</a>
  </div>
</footer>
